import { Box, Typography, useTheme } from "@mui/material";
import { useState } from "react";
import { ScreenSmallerThen } from "../../utilities/UIHelper";
import { MetricKPIs } from "../MetricKPIs";
import { AllKPIs } from "../modals/custom-fields/KPIsModal";
import { NavbarIcon } from "../../atoms/navbar/Icon";

type KPIsProps = {
  value: string[];
  parentObjectId: string;
  setEditing?: (value: boolean) => void;
};

export const KPIs = ({ value, parentObjectId, setEditing }: KPIsProps) => {
  const theme = useTheme();

  const [openAllKPIs, setOpenAllKPIs] = useState(false);

  const isSmallScreen1 = ScreenSmallerThen("1420px");
  const isSmallScreen2 = ScreenSmallerThen("1160px");
  const maxIndex = isSmallScreen2 ? 2 : isSmallScreen1 ? 3 : 4;

  return (
    <>
      <AllKPIs
        open={openAllKPIs}
        onClose={() => setOpenAllKPIs(false)}
        value={value}
        parentObjectId={parentObjectId}
      />
      <Box display="flex" gap="16px" width="100%" alignItems="center">
        <Box display="flex" gap="2px" alignItems="center">
          {value.length !== 0 ? (
            <Box display="flex" gap="20px" alignItems="center" width="100%">
              {value?.map((metric: any, index: number) => {
                return index < maxIndex ? (
                  <MetricKPIs key={index} metricId={metric} parentObjectId={parentObjectId} />
                ) : null;
              })}
            </Box>
          ) : (
            <Box
              height="100%"
              padding="6.5px 12px"
              display="flex"
              alignItems="center"
              gap="8px"
              border={`1px solid ${theme.palette.custom.primaryBorder}`}
              borderRadius="3px"
              sx={{
                backgroundColor: theme.palette.custom.primaryBackground,
                cursor: "pointer",
                ":hover": {
                  backgroundColor: theme.palette.custom.grey[50],
                },
              }}
              onClick={() => setEditing && setEditing(true)}
            >
              <NavbarIcon
                variant="kpi"
                sx={{
                  width: "17px",
                  height: "12px",
                }}
              />
              <Typography variant="h3">Add your first KPI</Typography>
            </Box>
          )}
        </Box>
        {value.length > maxIndex && (
          <Box
            height="100%"
            padding="6.5px 12px"
            display="flex"
            alignItems="center"
            gap="8px"
            border={`1px solid ${theme.palette.custom.primaryBorder}`}
            borderRadius="3px"
            sx={{
              backgroundColor: theme.palette.custom.primaryBackground,
              cursor: "pointer",
              ":hover": {
                backgroundColor: theme.palette.custom.grey[50],
              },
            }}
            onClick={() => setOpenAllKPIs(true)}
          >
            <NavbarIcon
              variant="kpi"
              sx={{
                width: "17px",
                height: "12px",
              }}
            />
            <Typography variant="h3">{`${value.length - maxIndex} More KPIs`}</Typography>
          </Box>
        )}
      </Box>
    </>
  );
};
